import { PlatformModel } from '~/models/PlatformModel';
import { MFAStatus } from '~/repositories/UserRepository';

import { LoginAuthMethod } from './LoginAuthMethod';

export const isAllowedAppAccess = (
  currentPlatform?: PlatformModel,
  mfaStatus?: MFAStatus,
  loginAuthMethod?: LoginAuthMethod
): boolean => {
  return (
    currentPlatform !== undefined &&
    (!currentPlatform.isLiveEnabled ||
      mfaStatus === MFAStatus.VERIFIED ||
      mfaStatus === MFAStatus.VERIFIED_LEGACY ||
      loginAuthMethod === LoginAuthMethod.PASSKEY)
  );
};
